import React from "react";

import StartPage from "./pages/StartPage";

function App(props) {
    return (
        <div className="App">
            <StartPage history={props.history} />
        </div>
    );
}

export default App;
